<template>
    <a :href="link" class="card--icon h-100 pa-20 pa-md-30 py-lg-44 px-lg-40">
        <div class="mb-18 mb-lg-38">
            <h4 class="tit--sm">
                {{tit}}
            </h4>
            <p class="page-text">
                {{sc}}
            </p>
        </div>
        <div class="d-flex justify-end">
            <v-img :src="icon" max-width="192"></v-img>
        </div>
    </a>
</template>

<script>

export default{
    props : {
        link : {type :String, default : ""},
        tit : {type :String, default : ""},
        sc : {type :String, default : ""},
        icon : {type :String, default : ""},
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
	// 	}
	// },
}
</script>

<style scoped>
.card--icon{
    display: block;
    border-radius: 20px;
    background-color: #ebf5ff;
    position: relative;
    transition: 0.15s ease-out;
}
.card--icon::after{
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 20px;
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: 2px solid #2e60ef;
    opacity: 0;
    visibility: hidden;
    transition: 0.15s ease-out;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .card--icon:hover{
        color: #2e60ef;
    }
    .card--icon:hover::after{
        opacity: 1;
        visibility: visible;
    }
}
@media (min-width:1200px){
}

</style>